<template>
	<el-card class="guest-container">
		<template #header>
			<div class="header">
				<el-button type="primary" size="small" icon="el-icon-plus" @click="edit('')">新增</el-button>
				<!-- <el-button type="primary" size="small" icon="el-icon-plus" @click="addAdmin">新增</el-button> -->
				<!-- <el-button type="primary" size="small" icon="el-icon-plus" @click="handleSolve">解除禁用</el-button>
	        <el-button type="danger" size="small" icon="el-icon-delete" @click="handleForbid">禁用账户</el-button> -->
			</div>
		</template>
		<el-table v-loading="loading" ref="multipleTable" :data="list" tooltip-effect="dark" style="width: 100%">
			<el-table-column prop="id" label="ID" width="40">
			</el-table-column>
			<el-table-column prop="vip_name" label="会员等级名称">
			</el-table-column>
			<el-table-column prop="description" label="会员等级描述">
			</el-table-column>
			<el-table-column prop="image" label="会员等级图标">
				<template v-slot="scope">
					<el-image :src='this.getImgPrefix()+scope.row.image' style='width: 30px;' fit='contain' ></el-image>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="auto">
				<template #default="scope">
					<el-button type="primary" size="mini" @click="edit(scope.row)">编辑</el-button>
					<el-button v-if="this.localGet('userId')==1" type="warning" size="mini" @click="del(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!--总数超过一页，再展示分页器-->
		<!-- <el-pagination
	      background
	      layout="prev, pager, next"
	      :total="total"
	      :page-size="pageSize"
	      :current-page="currentPage"
	      @current-change="changePage"
	    /> -->
	</el-card>
	<el-dialog title="会员等级管理" v-model="dialogFormVisible">
		<el-form :model="form" ref='form' :rules="rules">
			<el-form-item prop="vip_name" label="会员等级名称" :label-width="formLabelWidth">
				<el-input v-model="form.vip_name" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item prop="description" label="会员等级描述" :label-width="formLabelWidth">
				<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.description">
				</el-input>
			</el-form-item>
			<el-form-item label="会员等级图片" prop="image" :label-width="formLabelWidth">
				<!-- 单文件上传 -->
				<upload buttonTitle='上传' upload_path='upload_vip_grade' :resize='890' @success-upload='imgSuccess_SingleFile'></upload>
				<div class="row-no-full" style="flex-wrap: wrap;">
					<div v-for="(v,i) in form.image" :key='i'  style="margin-right: 30px;">
						<div class="col">
							<div class="demo-image__preview">
								<el-image :src='this.getImgPrefix()+v' style='width: 120px;' fit='contain' ></el-image>
							</div>
							<!-- <div class="row-no-full" style="justify-content: space-around">
								<upload buttonTitle="更换" upload_path='upload_vip_grade' type="warning" size="mini" @success-upload='updateSizeImg'
								 :customParams="[i]"></upload>
								<div>
									<el-button type='danger' size='mini' @click='delete_size_img(i)'>删除</el-button>
								</div>
							</div> -->
						</div>
					</div>
				</div>
			</el-form-item>
		</el-form>
		<template #footer>
			<span class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="submit()">确 定</el-button>
			</span>
		</template>
	</el-dialog>
</template>

<script>
	import Upload from '../common/Upload.vue'
	export default {
		name: 'VipGrade',
		components: {
			Upload
		},
		data() {
			return {
				list: [],
				loading: false,
				multipleSelection: [],
				vipGrade:[],
				dialogFormVisible: false,
				formLabelWidth: '120px',
				form: {
					vip_name: '',
					description: '',
					image:[],
				},
				rules: {
					vip_name: [{
						required: true,
						message: '会员等级名称不能为空',
						trigger: 'blur'
					}],
					image: [{
						required: true,
						message: '会员等级图片必须上传',
						trigger: 'change'
					}],
				}
			}
		},
		methods: {
			getVipGrade() {
				this.httpPost({
					url: '/admin/vipgrade/get_vip_grade_all',
					data:{
						routePath: this.$route.path
					}
				}).then((res) => {
					this.list = res.data;
				})
			},
			edit(val) {
				// console.log(val)
				this.dialogFormVisible = true;
				let temp = this.cloneObj(val);
					if (val) {
						this.form = temp;
					} else {
						this.resetObj(this.form)
					}
				this.$nextTick(() => {
					this.$refs['form'].clearValidate();
				})
			},
			submit() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.updateVipGrade();
					} else {
						console.log('error submit!')
						return false;
					}
				})
			},
			imgSuccess_SingleFile(e) {
				// console.log(this.form);return;
				// 上传单文件
				// console.log(this.productSizeList)
				if (this.form.image.length > 0) {
					this.form.image.splice(0, 1) //商品尺码 每次删掉前一次上传的
				}
				
				this.form.image.push(e)
			},
			updateSizeImg(e, params) {
				//更换商品尺码 图片
				// console.log(e)
				// console.log(params)
				let imgSizeOldPath = this.form.img[params[0]] //更改之前的图片路径
				this.httpPost({
					url: '/admin/upload/uploadProductSizeUpdate',
					data: {
						imgSizeOldPath: imgSizeOldPath,
					}
				}).then((re) => {
					// console.log(re)
					if (re.code > 1) return this.$message.error(re.msg)
					if (this.productSizeList.length > 0) {
						this.productSizeList.splice(params[0], 1, this.getImgPrefix() + e) //商品尺码 展示大图 每次删掉前一次的  只保留一张图片
					}
					this.item.product_size_img.splice(params[0], 1, e) //点击 更换按钮后 重新给 product_size_img 赋值
				})
			
			
			},
			updateVipGrade() {
				let temp = this.cloneObj(this.form);
				let id = temp.id;
				if (!id) id = '';
				this.msgBoxAjax(
					'提示',
					'确定修改吗？',
					"/admin/vipgrade/vip_grade_update?id=" + id,
					temp).then((data) => {
					// console.log(data);

					if (data.code == 1) {
						this.dialogFormVisible = false;
						this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
							this.getVipGrade();
						});
					} else {
						this.messageCommon('错误', data.msg, 'error');
					}
				});
			},
			del(val) {
				let id = val.id;
				console.log(id)
				this.msgBoxAjax(
					'提示',
					'确定删除吗？',
					"/admin/vipgrade/vip_grade_del", {
						id: id
					}).then((data) => {
					// console.log(data);

					if (data.code == 1) {
						this.dialogFormVisible = false;
						this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
							this.getVipGrade();
						});
					} else {
						this.messageCommon('错误', data.msg, 'error');
					}
				});
			}
		},
		created() {
			this.getVipGrade();
		}
	}
</script>

<style>
</style>
